import apolloClient from "@src/utilities/apollo-client"

import {
  GET_BUNDLE_PRICE_STOCK,
  GET_PRODUCT_PRICE_STOCK,
} from "@src/operations/api/product"

import type {
  GetBundlePriceStockQuery,
  GetBundlePriceStockQueryVariables,
  GetProductPriceStockQuery,
  GetProductPriceStockQueryVariables,
} from "@src/entities/types/api"

export async function getBundlePriceStock(
  skus: GetBundlePriceStockQueryVariables["skus"]
) {
  return apolloClient.query<
    GetBundlePriceStockQuery,
    GetBundlePriceStockQueryVariables
  >({
    query: GET_BUNDLE_PRICE_STOCK,
    variables: { skus },
  })
}

export async function getProductPriceStock(
  sku: GetProductPriceStockQueryVariables["sku"]
) {
  return apolloClient.query<
    GetProductPriceStockQuery,
    GetProductPriceStockQueryVariables
  >({
    query: GET_PRODUCT_PRICE_STOCK,
    variables: { sku },
  })
}
